import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

export default function SolicitudPermiso({ usuario, filtroABAC, onBackToMenu }) {
  const [datosEmpleado, setDatosEmpleado] = useState({
    nombres: '',
    documento: '',
    cargo: 'Cargando...',
    centroTrabajo: ''
  });

  const [formData, setFormData] = useState({
    tipo: 'Dias',
    cantidad: '',
    fechaInicio: '',
    fechaFin: '',
    motivo: ''
  });

  useEffect(() => {
    const usuarioLocal = JSON.parse(localStorage.getItem("usuario") || "{}");
    const token = localStorage.getItem("token");

    const fetchPerfilReal = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL;
        const baseUrl = API_URL.endsWith('/api') ? API_URL.slice(0, -4) : API_URL;

        const res = await fetch(`${baseUrl}/api/empleados/${usuarioLocal.documento}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (res.ok) {
          const data = await res.json();
          if (data.success && data.empleado) {
            const sedeReal = data.empleado.area_nombre || data.empleado.sede || data.empleado.centro_trabajo || data.empleado.area;
            
            setDatosEmpleado({
              nombres: usuarioLocal.nombres || '',
              documento: usuarioLocal.documento || '',
              cargo: data.empleado.cargo || 'Sin cargo asignado',
              centroTrabajo: sedeReal || usuarioLocal.sede || usuarioLocal.centroTrabajo || 'Sin sede asignada'
            });
          }
        } else {
          throw new Error("Error en petición");
        }
      } catch (error) {
        setDatosEmpleado({
          nombres: usuarioLocal.nombres || '',
          documento: usuarioLocal.documento || '',
          cargo: usuarioLocal.cargo !== 'SUPER_ADMIN' ? usuarioLocal.cargo : 'Administrador del Sistema',
          centroTrabajo: usuarioLocal.area_nombre || usuarioLocal.sede || usuarioLocal.centroTrabajo || 'Sin sede asignada'
        });
      }
    };

    if (usuarioLocal.documento) {
      fetchPerfilReal();
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.cantidad || !formData.fechaInicio || !formData.fechaFin || !formData.motivo) {
      return Swal.fire({ 
        icon: 'warning', 
        title: 'Campos Incompletos', 
        text: 'Por favor complete todos los campos obligatorios.', 
        confirmButtonColor: '#3b82f6' 
      });
    }

    if (new Date(formData.fechaFin) < new Date(formData.fechaInicio)) {
      return Swal.fire({ 
        icon: 'error', 
        title: 'Fechas Inválidas', 
        text: 'La fecha y hora de finalización no pueden ser anteriores a las de inicio.', 
        confirmButtonColor: '#ef4444' 
      });
    }

    Swal.fire({ 
      title: 'Radicando solicitud...', 
      allowOutsideClick: false, 
      didOpen: () => Swal.showLoading() 
    });

    try {
      const API_URL = process.env.REACT_APP_API_URL ;
      const token = localStorage.getItem("token");
      
      const payloadCorrecto = {
        documento_empleado: datosEmpleado.documento,
        nombres_empleado: datosEmpleado.nombres,
        cargo_empleado: datosEmpleado.cargo,
        area_empleado: datosEmpleado.centroTrabajo,
        tipo_tiempo: formData.tipo,
        cantidad_tiempo: formData.cantidad,
        fecha_inicio: formData.fechaInicio,
        fecha_fin: formData.fechaFin,
        motivo: formData.motivo,
        sede_id: null
      };

      // Limpieza de URL para evitar duplicidad del prefijo /api
      const baseUrl = API_URL.endsWith('/api') ? API_URL.slice(0, -4) : API_URL;

      const res = await fetch(`${baseUrl}/api/th/solicitud`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}` 
        },
        body: JSON.stringify(payloadCorrecto)
      });

      if (res.ok) {
        Swal.fire({ 
          icon: 'success', 
          title: 'Permiso Radicado', 
          text: 'Su solicitud ha sido enviada exitosamente a Talento Humano.', 
          confirmButtonColor: '#3b82f6' 
        });
        setFormData({ tipo: 'Dias', cantidad: '', fechaInicio: '', fechaFin: '', motivo: '' });
      } else {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || 'Error en la petición');
      }
    } catch (error) {
      Swal.fire({ 
        icon: 'error', 
        title: 'Error de Conexión', 
        text: 'No se pudo radicar la solicitud. Intente nuevamente.', 
        confirmButtonColor: '#ef4444' 
      });
    }
  };

  return (
    <div className="bg-slate-50/80 backdrop-blur-3xl p-6 sm:p-8 rounded-[32px] shadow-sm border border-white w-full max-w-4xl mx-auto">
      
      <div className="flex justify-between items-center mb-8 pb-6 border-b border-gray-200">
        <div>
          <h2 className="text-2xl font-extrabold text-gray-900">📝 FO-TH-96: Solicitud de Permiso Laboral</h2>
          <p className="text-xs text-gray-500 mt-1">Diligencie los datos para radicar su permiso ante su jefatura y Talento Humano.</p>
        </div>
        <button 
          type="button"
          onClick={onBackToMenu} 
          className="px-4 py-2 text-xs font-bold bg-white rounded-full border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors shadow-sm"
        >
          Volver
        </button>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-6">
        
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 bg-white p-4 rounded-2xl border border-gray-200 shadow-sm">
          <div>
            <span className="block text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">Colaborador:</span>
            <span className="text-xs font-extrabold text-blue-900 uppercase">{datosEmpleado.nombres}</span>
          </div>
          <div>
            <span className="block text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">Cargo:</span>
            <span className="text-xs font-extrabold text-blue-900 uppercase">{datosEmpleado.cargo}</span>
          </div>
          <div>
            <span className="block text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">Área / Sede:</span>
            <span className="text-xs font-extrabold text-blue-900 uppercase">{datosEmpleado.centroTrabajo}</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-bold uppercase mb-1">Solicitar por:</label>
            <div className="flex items-center gap-6 bg-white border border-gray-200 rounded-xl px-4 py-2.5">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" name="tipo" value="Dias" checked={formData.tipo === 'Dias'} onChange={handleChange} className="w-4 h-4 text-blue-600" />
                <span className="text-xs font-bold text-gray-700">Días</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="radio" name="tipo" value="Horas" checked={formData.tipo === 'Horas'} onChange={handleChange} className="w-4 h-4 text-blue-600" />
                <span className="text-xs font-bold text-gray-700">Horas</span>
              </label>
            </div>
          </div>
          
          <div>
            <label className="block text-xs font-bold uppercase mb-1">Cantidad ({formData.tipo}):</label>
            <input 
              type="number" 
              name="cantidad" 
              value={formData.cantidad} 
              onChange={handleChange} 
              min="1" 
              className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-xs font-bold" 
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-bold uppercase mb-1">Fecha y Hora de Inicio:</label>
            <input 
              type="datetime-local" 
              name="fechaInicio" 
              value={formData.fechaInicio} 
              onChange={handleChange} 
              className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-xs font-bold" 
            />
          </div>
          
          <div>
            <label className="block text-xs font-bold uppercase mb-1">Fecha y Hora de Finalización:</label>
            <input 
              type="datetime-local" 
              name="fechaFin" 
              value={formData.fechaFin} 
              onChange={handleChange} 
              className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-xs font-bold" 
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-bold uppercase mb-1">Razones / Justificación del Permiso:</label>
          <textarea 
            name="motivo" 
            value={formData.motivo} 
            onChange={handleChange} 
            rows="4" 
            placeholder="Escriba detalladamente el motivo de su solicitud..." 
            className="w-full bg-white border border-gray-200 rounded-xl p-4 text-xs font-bold resize-none"
          ></textarea>
        </div>

        <div className="flex justify-end pt-4">
          <button 
            type="submit" 
            className="px-6 py-3 bg-blue-600 text-white text-xs font-bold rounded-full shadow-md cursor-pointer hover:bg-blue-700 transition-colors"
          >
            Radicar Solicitud
          </button>
        </div>
      </form>
    </div>
  );
}